module.exports = __webpack_public_path__ + "static/img_1875-b798f6439ba475ca8522ff8ae37ccc4b.webp";